import { useEffect, useState } from "react";
import "../../assets/css/claim-carousel.css";

export default function ClaimCarousel({
  items = [],
  autoRotate = 3000
}) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (items.length === 0) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % items.length);
    }, autoRotate);
    return () => clearInterval(timer);
  }, [items.length, autoRotate]);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="claim-carousel-container">
      <div
        className="claim-carousel-inner"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {items.map((item, index) => (
          <div className="claim-item" key={index}>
            <div className="claim-section">
              <div className="claim-icon">
                <img src={item.icon} alt={item.title} />
              </div>
              <h5 className="claim-text">{item.title}</h5>
            </div>
          </div>
        ))}
      </div>

      <div className="claim-dots">
        {items.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </div>
  );
}
